import KITCHEN_ITEMS from '../data/kitchenItems';

const normalize = (s) => s.toLowerCase().replace(/[^a-z0-9 ]/g, '');

const fuzzyMatch = (query, target) => {
  const q = normalize(query);
  const t = normalize(target);
  if (t === q) return 1;
  if (t.startsWith(q)) return 0.9;
  if (t.includes(q)) return 0.7;
  const words = q.split(/\s+/);
  const matched = words.filter((w) => t.includes(w)).length;
  return matched > 0 ? 0.3 + (matched / words.length) * 0.3 : 0;
};

export const searchLocal = (query, limit = 20) => {
  if (!query || query.trim().length < 2) return [];
  const scored = KITCHEN_ITEMS
    .map((item) => ({ ...item, score: fuzzyMatch(query, item.name), source: 'local' }))
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit);
};

let abortController = null;

export const searchAPI = async (query, limit = 10) => {
  if (!query || query.trim().length < 3) return [];

  if (abortController) abortController.abort();
  abortController = new AbortController();

  const url = `https://world.openfoodfacts.org/cgi/search.pl?search_terms=${encodeURIComponent(query)}&search_simple=1&action=process&json=1&page_size=${limit}&fields=product_name,categories_tags,quantity`;

  try {
    const res = await fetch(url, { signal: abortController.signal });
    if (!res.ok) return [];
    const data = await res.json();
    return (data.products || [])
      .filter((p) => p.product_name)
      .map((p) => {
        const cats = (p.categories_tags || []).map((c) => c.replace(/^en:/, '').replace(/-/g, ' '));
        return {
          name: p.product_name,
          category: cats[0] || 'Other',
          unit: 'grams',
          shelfDays: null,
          source: 'api',
        };
      });
  } catch (err) {
    if (err.name === 'AbortError') return [];
    return [];
  }
};

export const searchAll = async (query, localLimit = 15, apiLimit = 10) => {
  const localResults = searchLocal(query, localLimit);

  if (localResults.length >= localLimit || query.trim().length < 3) {
    return localResults;
  }

  const apiResults = await searchAPI(query, apiLimit);
  const localNames = new Set(localResults.map((r) => r.name.toLowerCase()));
  const deduped = apiResults.filter((r) => !localNames.has(r.name.toLowerCase()));
  return [...localResults, ...deduped];
};
